const width = window.innerWidth;
const height = window.innerHeight;

export { width, height };
